import axios from 'axios';
import { getCookie } from '../common/utils/cookie';
// import moment from 'moment';
// eslint-disable-next-line
import { store } from '../store';

export function checkIfLoggedIn() {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('SessionToken');
    if (!token) {
      // Don't bother hitting the api if no token is set.
      reject(new Error('No valid token available.'));
    }
    axios({
      method: 'get',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/check-if-logged-in/`,
      headers: { Authorization: `Token ${token}` },
      params: { site: process.env.REACT_APP_HOSTNAME || window.location.hostname },
    }).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
}

export function refreshSession() {
  return new Promise((resolve, reject) => {
    const sessionToken = localStorage.getItem('SessionToken');
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/token-auth/refresh/`,
      method: 'post',
      headers: { Authorization: `Token ${sessionToken}` },
      data: { sessionToken },
    }).then(({ status, data }) => {
      if (status === 201) {
        const { token, created, lifespan } = data;
        localStorage.setItem('SessionToken', token);
        store.dispatch({ type: 'SET_TOKEN_CREATED', payload: created });
        store.dispatch({ type: 'SET_TOKEN_LIFESPAN', payload: lifespan });
        resolve();
      }
    }).catch(err => {
      store.dispatch({ type: 'CLEAR_SESSION' });
      localStorage.removeItem('SessionToken');
      window.location = '/login';
      reject(err);
    });
  });
}

export async function setAuthFromCookie() {
  const token = getCookie('enrollmentToken');
  window.localStorage.setItem('SessionToken', token);
}

export async function validateSession() {
  const token = localStorage.getItem('SessionToken');
  const site = process.env.REACT_APP_HOSTNAME || window.location.hostname;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/check-if-logged-in/`,
    headers: { Authorization: `Token ${token}` },
    params: { site },
  });
}
